export { default as instantiateFaustModule } from './instantiateFaustModule';

export * from './instantiateFaustModule';

export * from './exports';
